'use es6';

import PortalIdParser from 'PortalIdParser';
import noAuthHttp from '../../http/noAuthApiClient';
import authHttp from '../../http/apiClient';
export function createVisitorThread({
  sessionId,
  messageId,
  hubspotUtk,
  messagesPageUri,
  visitorThreadInitialHistory,
  zoneId
}) {
  const isInPreview = new URLSearchParams(window.location.search).get('preview') === 'true';
  const url = isInPreview ? `livechat/v1/thread/visitor/preview/create` : `livechat-public/v1/thread/visitor/create`;
  const data = {
    visitorMessage: visitorThreadInitialHistory[visitorThreadInitialHistory.length - 1],
    expectedInitialHistory: visitorThreadInitialHistory.slice(0, -1).map(message => message.richText || message.text)
  };
  const client = isInPreview ? authHttp : noAuthHttp;
  return client.post(url, {
    query: {
      sessionId,
      welcomeMessageId: messageId,
      hubspotUtk,
      portalId: PortalIdParser.get(),
      expectedResponseType: 'WRAPPER_V2',
      zoneId
    },
    data,
    headers: {
      'X-HubSpot-Messages-Uri': messagesPageUri
    }
  });
}